import React, { useCallback } from 'react';
import { RedirectBasedPayment } from '../common/GenericPayment/RedirectBasedPayment';

export const GenericForm = ({
  flow,
  loading,
  onPay,
  permitIdentifier,
  totalDue,
  error,
}) => {
  const handleClickCallback = useCallback(async () => {
    const { url } = await onPay();
    return { url };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permitIdentifier, flow]);

  return (
    <RedirectBasedPayment
      totalDue={totalDue}
      onClickCallback={handleClickCallback}
      loading={loading}
      error={error}
      dataTestId="generic-form-component"
    >
      The button below will take you to our third-party payment system to make
      your payment.
    </RedirectBasedPayment>
  );
};
